// imports
import { InputBaseComponentProps, TextField } from '@mui/material';
import { FC, forwardRef, useImperativeHandle, useState } from 'react';
import { CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js';
// interface
import { StripeElement, StripeTextFieldCVCProps, StripeTextFieldExpiryProps, StripeTextFieldNumberProps, StripeTextFieldProps } from '../app/interfaceTypes';

const StripeInput = forwardRef<HTMLDivElement, InputBaseComponentProps>(function StripeInput(props, ref) {
  const { component: Component, ...other } = props;
  const [mountNode, setMountNode] = useState<HTMLDivElement | null>(null);

  useImperativeHandle(
    ref,
    () =>
      ({
        focus: () => mountNode?.focus()
      }) as HTMLDivElement,
    [mountNode]
  );

  return <Component onReady={setMountNode} {...other} />;
});

export const StripeTextField: FC = <T extends StripeElement>(props: StripeTextFieldProps<T>) => {
  const { error, helperText, stripeElement, inputProps, labelErrorMessage, ...other } = props;

  return (
    <TextField
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      {...(other as any)}
      fullWidth
      InputProps={{
        ...other.InputProps,
        inputComponent: StripeInput as any,
        inputProps: {
          ...inputProps,
          component: stripeElement
        }
      }}
      InputLabelProps={{
        shrink: true,
        ...(other.InputLabelProps || {})
      }}
      error={error}
      helperText={error ? labelErrorMessage : helperText}
    />
  );
};

export const StripeTextFieldNumber: FC<StripeTextFieldNumberProps> = (props) => {
  return <StripeTextField stripeElement={CardNumberElement} {...props} />;
};

export const StripeTextFieldExpiry: FC<StripeTextFieldExpiryProps> = (props) => {
  return <StripeTextField stripeElement={CardExpiryElement} {...props} />;
};

export const StripeTextFieldCVC: FC<StripeTextFieldCVCProps> = (props) => <StripeTextField stripeElement={CardCvcElement} {...props} />;
